var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed w-full p-3 z-50 top-0 h-0 m-auto"},_vm._l((_vm.notifications),function(notification,index){return _c('Notification',{key:index,attrs:{"message":notification.message,"description":notification.description}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }